/* Upsell popup na add-to-cart — toont de native theme-modal vóór de cart drawer opent. */
if (!customElements.get('atc-upsell-modal')) {
  class AtcUpsellModal extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('modal-dialog');
      this.shown = false;
      this.openDrawerOnClose = false;

      // Verplaats de modal naar <body>: genest in de productkolom erven we een
      // stacking context waardoor paginalijnen door de popup heen tekenen.
      if (this.modal && this.modal.parentElement !== document.body) {
        document.body.appendChild(this.modal);
      }
      this.addBtn = this.modal.querySelector('.js-upsell-add');
      this.errorEl = this.modal.querySelector('.js-upsell-error');

      this.addBtn.addEventListener('click', this.addToCart.bind(this));

      // De theme-modal sluit zichzelf (kruisje, backdrop, Escape, js-close-modal);
      // via het 'open'-attribuut zien we dat en openen we alsnog de drawer.
      this.observer = new MutationObserver(() => {
        if (!this.modal.hasAttribute('open') && this.openDrawerOnClose) {
          this.openDrawerOnClose = false;
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
        }
      });
      this.observer.observe(this.modal, { attributes: true, attributeFilter: ['open'] });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.modal && this.modal.parentElement === document.body) {
        this.modal.remove();
      }
    }

    /**
     * Toont de popup als de toegevoegde regel bij dit product hoort.
     * @param {object} data - Response van /cart/add (line item JSON).
     * @returns {boolean} true als de popup is geopend (drawer-open wordt dan overgenomen).
     */
    maybeShow(data) {
      if (this.shown) return false;
      if (!data || Number(data.product_id) !== Number(this.dataset.productId)) return false;
      this.shown = true;
      this.openDrawerOnClose = true;
      this.modal.open(this);
      return true;
    }

    async addToCart() {
      if (this.addBtn.getAttribute('aria-disabled') === 'true') return;
      this.addBtn.setAttribute('aria-disabled', 'true');
      this.addBtn.classList.add('is-loading');
      this.errorEl.hidden = true;

      const themeGlobal = window.theme || {};
      const routes = themeGlobal.routes || {};
      const cartDrawer = document.querySelector('cart-drawer');

      let sections = 'cart-icon-bubble';
      if (cartDrawer) {
        sections += `,${cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      try {
        const response = await fetch(routes.cartAdd || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{ id: Number(this.addBtn.dataset.variantId), quantity: 1 }],
            sections,
            sections_url: window.location.pathname
          })
        });
        const data = await response.json();

        if (!response.ok) {
          throw new Error(typeof data.description === 'string' ? data.description : (data.message || `HTTP ${response.status}`));
        }

        this.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { cart: data } }));

        this.openDrawerOnClose = false;
        this.modal.close();

        if (!cartDrawer) {
          window.location.href = routes.cart || '/cart';
        } else if (typeof cartDrawer.renderContents === 'function' && data.sections) {
          const cartIconBubble = document.getElementById('cart-icon-bubble');
          if (cartIconBubble && data.sections['cart-icon-bubble']) {
            cartIconBubble.innerHTML = data.sections['cart-icon-bubble'];
          }
          cartDrawer.renderContents(data);
        }
      } catch (error) {
        this.errorEl.textContent = (error && error.message) || 'Toevoegen is niet gelukt. Probeer het opnieuw.';
        this.errorEl.hidden = false;
      } finally {
        this.addBtn.classList.remove('is-loading');
        this.addBtn.removeAttribute('aria-disabled');
      }
    }
  }

  customElements.define('atc-upsell-modal', AtcUpsellModal);
}
